/* nue daily — founder pricing line conditional hide (M2) */
(function () {
  'use strict';

  function isFounderText(el) {
    return el.textContent.trim().toLowerCase() === 'founder pricing';
  }

  function check() {
    var hasDiscount = !!document.querySelector('.price--on-sale');
    var founders = Array.from(document.querySelectorAll('strong')).filter(isFounderText);
    founders.forEach(function (el) {
      el.style.display = hasDiscount ? '' : 'none';
      var parent = el.parentElement;
      if (parent && parent.children.length === 1) {
        var siblingText = parent.textContent.replace(el.textContent, '').trim();
        if (!siblingText) parent.style.display = hasDiscount ? '' : 'none';
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', check);
  } else {
    check();
  }

  document.addEventListener('variant:change', function () {
    setTimeout(check, 100);
  });
})();